import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";

export const EventGalleryListConfig = {
  columns: [
    {
      name: "Event",
      fieldName: "eventName",
      // colStyle: {
      //     width: "15%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // },
      allowShort: false,
    },

    {
      name: "Date",
      fieldName: "eventDate",
      colType: GridColumnType.DATE,
      colSettings: {
        format: "DD-MMM-YYYY",
      },
      allowShort: false,
      // colStyle: {
      //     width: "15%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // }
    },
    {
      name: "Status",
      fieldName: "isPublish",
      allowShort: false,
      // colStyle: {
      //     width: "40%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // }
    },
    {
      name: "Display Status",
      fieldName: "isPrivate",
      allowShort: false,
      // colStyle: {
      //     width: "15%",
      //     textAlign: "center",
      //     color: "color",
      //     backgroundColor: "white"
      // }
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
      allowShort: false,
    },
  ],
  allowEdit: false,
  isRowSelectable: true,
  hasChildGridTable: false,
  gridStyle: {
    tableClass: "border-table-simple",
  },
};
